import { TeamsSummaryTable } from './components/TeamsSummaryTable';

const TeamsSummary = () => (
  <TeamsSummaryTable />
);

export {
  TeamsSummary,
};
